import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';

import { Z_INDEX } from '@/constants/zIndex';

const slideLeft = keyframes`
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(0%);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  z-index: ${Z_INDEX.planModalDimmer};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.zinc_700};
  opacity: 0.25;
`;

export const FlexHeader = styled(Flex)`
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.zinc_200};
`;

export const SplitPanel = styled(Flex)`
  position: fixed;
  z-index: ${Z_INDEX.planModalContainer};
  top: 0;
  right: 0;
  overflow: hidden;
  width: 345px;
  height: calc(100% - 96px);
  margin: 48px 0;

  animation: ${slideLeft} 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px 0 0 8px;
`;

export const SplitComparisonArea = styled.div`
  position: fixed;
  z-index: ${Z_INDEX.planModalContents};
  top: 0;
  left: 0;

  display: flex;
  overflow: hidden;

  width: calc(100% - 361px);
  height: 100%;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px;
`;
